import React, { useState } from "react";
import styled from "styled-components";
import { FaBars } from "react-icons/fa6";
import { VerticalNavigation } from "./VerticaltNavigation";

const NavOuter = styled.div `
    display:flex;
    justify-content: flex-end;
`;

const Nav = styled.div `
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: right;
    padding: '10px';
`;

const NavButton = styled.button `
    color: ${({content}) => content.titleTextColor};
    background: ${({content}) => content.titleBgColor};
    text-align: right;
    text-decoration: none;
    border: none;
    font-size: 1.25rem;
    width: '30px';  
    cursor: pointer;
`;


export default function BarNav({content}) {

    const [navVisible, setNavVisible] = useState(false);

    const toggleNavVisible = () => {
        setNavVisible((navVisible) => !navVisible);
      };
    
    if (navVisible) {
        return (
            <NavOuter className='nav-outer'>
                <Nav content={content.styles} className='nav'>
                    <NavButton content={content.styles} onClick={toggleNavVisible} ><FaBars/></NavButton>
                    <VerticalNavigation content={{...content, highlightColor: null}} onClick={toggleNavVisible} width='auto'/>
                </Nav>
            </NavOuter>
        )    
    } else {
        return (
            <NavOuter className='nav-outer'>
                <NavButton content={content.styles} onClick={toggleNavVisible}><FaBars/></NavButton>
            </NavOuter>
        )    
    }

}